// ===== CARRITO DE COMPRAS =====
let cart = [];

function formatPrice(num) {
  return '$' + num.toLocaleString('es-CO');
}

function addToCart(name, price, category) {
  const existing = cart.find(i => i.name === name);
  if (existing) {
    existing.qty++;
  } else {
    cart.push({ name, price, qty: 1, category });
  }
  updateCartUI();
  showToast('✅ ' + name + ' agregado al carrito');

  // Animación visual en el botón del carrito
  const cartBtn = document.getElementById('cartBtn');
  cartBtn.classList.add('cart-bump');
  setTimeout(() => cartBtn.classList.remove('cart-bump'), 400);
}

function removeFromCart(name) {
  cart = cart.filter(i => i.name !== name);
  updateCartUI();
}

function changeQty(name, delta) {
  const item = cart.find(i => i.name === name);
  if (!item) return;
  item.qty += delta;
  if (item.qty <= 0) {
    cart = cart.filter(i => i.name !== name);
  }
  updateCartUI();
}

function clearCart() {
  cart = [];
  updateCartUI();
}

function getTotal() {
  return cart.reduce((sum, i) => sum + i.price * i.qty, 0);
}

function getTotalItems() {
  return cart.reduce((sum, i) => sum + i.qty, 0);
}

function updateCartUI() {
  const total = getTotal();
  const count = getTotalItems();

  // --- Badge del navbar ---
  const badge = document.getElementById('cartCount');
  if (badge) badge.textContent = count;

  // --- Sidebar: lista de items ---
  const cartItemsEl = document.getElementById('cartItems');
  const cartFooter  = document.getElementById('cartFooter');

  if (cartItemsEl) {
    if (cart.length === 0) {
      cartItemsEl.innerHTML = '<p class="empty-cart">Tu carrito está vacío</p>';
      if (cartFooter) cartFooter.style.display = 'none';
    } else {
      cartItemsEl.innerHTML = cart.map(item => `
        <div class="cart-item-row">
          <div class="cart-item-name">${item.name}</div>
          <div class="cart-item-qty">
            <button class="qty-btn" onclick="changeQty('${item.name.replace(/'/g,"\\'")}', -1)">−</button>
            <span class="qty-num">${item.qty}</span>
            <button class="qty-btn" onclick="changeQty('${item.name.replace(/'/g,"\\'")}', 1)">+</button>
          </div>
          <div class="cart-item-price">${formatPrice(item.price * item.qty)}</div>
        </div>
      `).join('');
      if (cartFooter) {
        cartFooter.style.display = 'flex';
        cartFooter.style.flexDirection = 'column';
        cartFooter.style.gap = '12px';
      }
      const cartTotalEl = document.getElementById('cartTotal');
      if (cartTotalEl) cartTotalEl.textContent = formatPrice(total);
    }
  }

  // --- Sección de resumen del pedido ---
  const orderItemsEl  = document.getElementById('orderItems');
  const orderTotalWrap = document.getElementById('orderTotalWrap');

  if (orderItemsEl) {
    if (cart.length === 0) {
      orderItemsEl.innerHTML = '<p class="empty-cart">No hay productos en el carrito.<br>Agrégalos desde la sección de productos.</p>';
      if (orderTotalWrap) orderTotalWrap.style.display = 'none';
    } else {
      orderItemsEl.innerHTML = cart.map(item => `
        <div class="cart-item-row">
          <div class="cart-item-name">${item.name} × ${item.qty}</div>
          <div class="cart-item-price">${formatPrice(item.price * item.qty)}</div>
        </div>
      `).join('');
      if (orderTotalWrap) orderTotalWrap.style.display = 'block';
      const sub = document.getElementById('subtotalVal');
      const tot = document.getElementById('totalVal');
      if (sub) sub.textContent = formatPrice(total);
      if (tot) tot.textContent = formatPrice(total);
    }
  }
}

// ===== CART SIDEBAR TOGGLE =====
function toggleCart() {
  const sidebar = document.getElementById('cartSidebar');
  const overlay = document.getElementById('cartOverlay');
  if (!sidebar || !overlay) return;
  const isOpen = sidebar.classList.toggle('open');
  overlay.classList.toggle('open');
  document.body.style.overflow = isOpen ? 'hidden' : '';
}

// ===== MOBILE MENU =====
function toggleMenu() {
  const menu = document.getElementById('mobileMenu');
  if (menu) menu.classList.toggle('open');
}

// ===== PRODUCT FILTER TABS =====
// FIX: recibe el elemento del botón como parámetro en vez de usar `event` global
function filterProducts(category, btnEl) {
  const cards = document.querySelectorAll('.product-card');
  const tabs  = document.querySelectorAll('.tab-btn');

  tabs.forEach(t => t.classList.remove('active'));
  if (btnEl) btnEl.classList.add('active');

  cards.forEach(card => {
    if (category === 'todos' || card.dataset.category === category) {
      card.style.display = '';
    } else {
      card.style.display = 'none';
    }
  });
}

// ===== TOAST NOTIFICATION =====
let toastTimer = null;
function showToast(message) {
  const toast = document.getElementById('toast');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('show');
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('show'), 2800);
}

// ===== EMAILJS CONFIG =====
// Reemplaza estos 3 valores con los tuyos de emailjs.com
const EMAILJS_PUBLIC_KEY  = 'oAnOXj4ScuGvgje-1';   // Account → Public Key
const EMAILJS_SERVICE_ID  = 'service_43e0asi';     // del paso 2
const EMAILJS_TEMPLATE_ID = 'template_e29bjlb';    // del paso 3

const WHATSAPP_NUMBER = '573105123319';

// ===== ORDER SUBMIT =====
async function submitOrder() {
  if (cart.length === 0) {
    showToast('⚠️ Agrega productos al carrito primero');
    return;
  }

  const campos    = ['nombre', 'cedula', 'telefono', 'email', 'direccion', 'ciudad', 'departamento'];
  const etiquetas = ['Nombre', 'Cédula', 'Teléfono', 'Email', 'Dirección', 'Ciudad', 'Departamento'];

  for (let i = 0; i < campos.length; i++) {
    const el = document.getElementById(campos[i]);
    if (!el || !el.value.trim()) {
      showToast('⚠️ Por favor completa: ' + etiquetas[i]);
      if (el) el.focus();
      return;
    }
  }

  const nombre       = document.getElementById('nombre').value.trim();
  const cedula       = document.getElementById('cedula').value.trim();
  const telefono     = document.getElementById('telefono').value.trim();
  const email        = document.getElementById('email').value.trim();
  const direccion    = document.getElementById('direccion').value.trim();
  const ciudad       = document.getElementById('ciudad').value.trim();
  const departamento = document.getElementById('departamento').value.trim();
  const notas        = document.getElementById('notas').value.trim();
  const metodoPago   = document.querySelector('input[name="pago"]:checked').value;

  const metodosNombre = {
    nequi:         'Nequi',
    daviplata:     'Daviplata',
    transferencia: 'Transferencia bancaria',
    contraentrega: 'Contraentrega'
  };

  const productosHTML = cart.map(item =>
    `<tr>
      <td style="padding:8px 12px;border-bottom:1px solid #333;">${item.name}</td>
      <td style="padding:8px 12px;border-bottom:1px solid #333;text-align:center;">${item.qty}</td>
      <td style="padding:8px 12px;border-bottom:1px solid #333;text-align:right;">${formatPrice(item.price * item.qty)}</td>
    </tr>`
  ).join('');

  const productosTxt = cart.map(item =>
    '• ' + item.name + ' x' + item.qty + ' = ' + formatPrice(item.price * item.qty)
  ).join('\n');

  const total = formatPrice(getTotal());
  const fecha = new Date().toLocaleString('es-CO', { dateStyle: 'full', timeStyle: 'short' });

  const templateParams = {
    fecha,
    nombre,
    cedula,
    telefono,
    email_cliente:  email,
    direccion,
    ciudad,
    departamento,
    metodo_pago:    metodosNombre[metodoPago],
    notas:          notas || 'Sin notas',
    productos_texto: productosTxt,
    productos_html:  productosHTML,
    total,
    whatsapp_cliente: 'https://wa.me/57' + telefono.replace(/\D/g, ''),
  };

  const btn = document.getElementById('orderBtn');
  if (btn) { btn.disabled = true; btn.textContent = '⏳ ENVIANDO PEDIDO...'; }

  try {
    await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams, EMAILJS_PUBLIC_KEY);
    document.getElementById('modalOverlay').style.display = 'flex';
    clearCart();
    campos.forEach(c => { const el = document.getElementById(c); if (el) el.value = ''; });
    document.getElementById('notas').value = '';

  } catch (error) {
    console.error('EmailJS error:', error);
    showToast('⚠️ Error al enviar. Redirigiendo a WhatsApp...');
    const msgWA =
      '🛒 *NUEVO PEDIDO - IMPERIO 7*\n\n' +
      '📦 *PRODUCTOS:*\n' + productosTxt + '\n\n' +
      '💰 *TOTAL: ' + total + '*\n\n' +
      '👤 *CLIENTE:*\n' +
      '• Nombre: ' + nombre + '\n' +
      '• Cédula: ' + cedula + '\n' +
      '• Teléfono: ' + telefono + '\n' +
      '• Email: ' + email + '\n\n' +
      '📍 *ENVÍO:*\n' +
      '• ' + direccion + ', ' + ciudad + ', ' + departamento + '\n\n' +
      '💳 *PAGO:* ' + metodosNombre[metodoPago] +
      (notas ? '\n📝 Notas: ' + notas : '');

    setTimeout(() => {
      window.open('https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(msgWA), '_blank');
    }, 1500);

  } finally {
    if (btn) { btn.disabled = false; btn.textContent = '🚀 CONFIRMAR PEDIDO'; }
  }
}

function closeModal() {
  const m = document.getElementById('modalOverlay');
  if (m) m.style.display = 'none';
}

// ===== PAYMENT METHOD INFO =====
const paymentTexts = {
  nequi:         '📱 <strong>Nequi:</strong> Envía al número <strong>300 XXX XXXX</strong> a nombre de Imperio 7. Envía el comprobante por WhatsApp.',
  daviplata:     '🏦 <strong>Daviplata:</strong> Envía al número <strong>310 XXX XXXX</strong> a nombre de Imperio 7. Envía el comprobante por WhatsApp.',
  transferencia: '🏛️ <strong>Transferencia:</strong> Banco Bancolombia · CC: <strong>XXX-XXXXXX-XX</strong> · Tipo: Ahorros · A nombre de Imperio 7 S.A.S. Envía comprobante.',
  contraentrega: '🚚 <strong>Contraentrega:</strong> Pagas al recibir tu pedido. Solo disponible en ciudades con cobertura. Te confirmaremos disponibilidad.'
};

// ===== SCROLL TO PEDIDO =====
function scrollToPedido() {
  setTimeout(() => {
    const sec = document.getElementById('pedido');
    if (sec) sec.scrollIntoView({ behavior: 'smooth' });
  }, 300);
}

// ===== CONTACT FORM =====
function sendContact() {
  showToast('✅ Mensaje enviado. ¡Te respondemos pronto!');
}

// ===== NAVBAR SCROLL EFFECT =====
window.addEventListener('scroll', () => {
  const navbar = document.getElementById('navbar');
  if (navbar) {
    navbar.style.background = window.scrollY > 50
      ? 'rgba(10,10,10,0.98)'
      : 'rgba(10,10,10,0.92)';
  }
});

// ===== HERO PARTICLES =====
function createParticles() {
  const container = document.getElementById('particles');
  if (!container) return;
  for (let i = 0; i < 30; i++) {
    const p = document.createElement('div');
    p.classList.add('particle');
    p.style.left             = Math.random() * 100 + '%';
    p.style.animationDuration = (6 + Math.random() * 10) + 's';
    p.style.animationDelay   = (Math.random() * 8) + 's';
    const size = (2 + Math.random() * 4) + 'px';
    p.style.width = p.style.height = size;
    container.appendChild(p);
  }
}

// ===== SCROLL REVEAL =====
// FIX: no aplica opacity:0 a product-card para que los botones no queden bloqueados
function revealOnScroll() {
  const benefitCards  = document.querySelectorAll('.benefit-card, .contact-card');
  const productCards  = document.querySelectorAll('.product-card');

  // Animación suave solo para benefit y contact cards
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity   = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  benefitCards.forEach(card => {
    card.style.opacity    = '0';
    card.style.transform  = 'translateY(24px)';
    card.style.transition = 'opacity 0.5s ease, transform 0.5s ease, border-color 0.25s ease, box-shadow 0.25s ease';
    observer.observe(card);
  });

  // Product cards: solo transición visual hover, nunca opacity:0
  productCards.forEach(card => {
    card.style.transition = 'transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease';
  });
}

// ===== INIT =====
document.addEventListener('DOMContentLoaded', () => {
  createParticles();
  revealOnScroll();
  updateCartUI();

  // Tabs de filtro: pasar referencia del botón
  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const cat = this.getAttribute('data-filter');
      filterProducts(cat, this);
    });
  });

  // Método de pago: actualizar info visible
  document.querySelectorAll('input[name="pago"]').forEach(radio => {
    radio.addEventListener('change', function () {
      const detail = document.querySelector('.payment-detail p');
      if (detail) detail.innerHTML = paymentTexts[this.value];
    });
  });
});
